import React from 'react'
import { parentMutationInput } from 'lib/helpers/parent/forms'

const withEventHandlers = WrappedComponent => {
  return props => {
    const {
      createParent, // via withMutation
      form, // via withRedux
      token,
    } = props

    // perform GraphQL mutation
    const handleSubmit = e => {
      e.preventDefault()

      createParent({
        variables: {
          input: parentMutationInput({form})
        }
      })
    }

    return <WrappedComponent handleSubmit={handleSubmit} {...props} />
  }
}

export default withEventHandlers
